export default "__VITE_ASSET__Dwrt1MTa__"